import { styles, variants, WindowOverlayTheme } from '../WindowOverlayStyles.css';
import { baseTheme } from './WindowOverlayBaseTheme.css';
import { multiVariantStyles } from './WindowOverlayVariants.css';

/*******************
 * Component Theme
 *******************/

const WindowOverlayRedwoodTheme: WindowOverlayTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/
export { WindowOverlayRedwoodTheme };
